import { Stage, Layer, Image, Transformer } from "react-konva";
import React, { useState, useRef, useEffect } from "react";
import useImage from "use-image";
import { BiLayerMinus, BiLayerPlus } from "react-icons/bi";
import LayerImage from "./konva/LayerImage";
import SelectBackgroundEdit from "../../components/SelectBackgroundEdit";
import DashedLine from "./konva/DashedLine";
import TopBarDesign from "./TopBarDesign";
const Design = ({
  backgroundDesign,
  onChange,
  widthCanvas,
  ratio,
  layerID,
  selectLayer,
  onSelectLayer,
  backgrounds,
  onChangeBgCurrentEditID,
  onChangeBackground,
  onApplyAll
}) => {
  const [imageLayers, setImageLayers] = useState([]);
  const [menuVisiblePosition, setMenuVisiblePosition] = useState({
    x: 0,
    y: 0,
  });
  const [menuVisible, setMenuVisible] = useState(false);
  const [menuVisiblelayerID, setMenuVisibleLayerID] = useState(null);
  const [showCenterLines, setShowCenterLines] = useState({
    x: false,
    y: false,
  });
  const [showCenterLinesStatutBtn, setShowCenterLinesStatutBtn] = useState(false);

  const moveStep = 1;
  const centerThreshold = 1;

  const backgroundImage = useImage(backgroundDesign.imageUrl)[0];
  const transformerRef = useRef();
  const stateRef = useRef();

  var isCtrlPressed = false;

  useEffect(() => {
    onChange(imageLayers);
  }, [imageLayers]);

  const moveDashedLine = (node) => {
    const canvasCenterX = widthCanvas / 2;
    const canvasCenterY = widthCanvas / 2;
    const imageCenterX = node.x + node.width / 2;
    const imageCenterY = node.y + node.height / 2;

    // Kiểm tra xem hình ảnh có gần giữa không
    const nearCenterX =
      Math.abs(imageCenterX - canvasCenterX) < centerThreshold;
    const nearCenterY =
      Math.abs(imageCenterY - canvasCenterY) < centerThreshold;
    // Hiển thị đường kẻ nếu gần giữa
    setShowCenterLines({
      x: nearCenterX,
      y: nearCenterY,
    });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Control") {
      isCtrlPressed = true;
    }
    // Xử lý di chuyển bằng phím điều hướng
    if(!isCtrlPressed) return;
    setImageLayers((prev) =>
      prev.map((img) => {
        if (!img.isSelected) return img; // Chỉ di chuyển ảnh được chọn
        switch (e.key) {
          case "ArrowUp":
            img.y = img.y - moveStep;
            break;
          case "ArrowDown":
            img.y = img.y + moveStep;
            break;
          case "ArrowLeft":
            img.x = img.x - moveStep;
            break;
          case "ArrowRight":
            img.x = img.x + moveStep;
            break;
          default:
            break;
        }
        moveDashedLine(img);
        return img;
      })
    );
  };

  const handleKeyUp = (e) => {
    if (e.key === "Control") {
      isCtrlPressed = false;
      setShowCenterLines({
        x: false,
        y: false,
      });
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("keyup", handleKeyUp);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("keyup", handleKeyUp);
    };
  }, []);

  const handleDragEnd = (e, index) => {
    setShowCenterLines({ x: false, y: false });
    const node = e.target;
    const attrs = {};
    for (const [key, value] of Object.entries(node.attrs)) {
      if (
        ![
          "image",
          "draggable",
          "width",
          "height",
          "scaleX",
          "scaleY",
          "x",
          "y",
        ].includes(key)
      ) {
        attrs[key] = value;
      }
    }
    setImageLayers((prev) =>
      prev.map((img, i) =>
        i === index
          ? {
              ...attrs,
              ...img,
              x: node.x(),
              y: node.y(),
              ratio,
            }
          : img
      )
    );
  };

  const handleTransformEnd = (e, index) => {
    const node = e.target;
    const scaleX = isCtrlPressed ? 1 : node.scaleX();
    const scaleY = isCtrlPressed ? 1 : node.scaleY();
    const attrs = {};
    for (const [key, value] of Object.entries(node.attrs)) {
      if (
        ![
          "image",
          "draggable",
          "width",
          "height",
          "scaleX",
          "scaleY",
          "x",
          "y",
        ].includes(key)
      ) {
        attrs[key] = value;
      }
    }
    setImageLayers((prev) =>
      prev.map((img, i) =>
        i === index
          ? {
              ...attrs,
              ...img,
              x: node.x(),
              y: node.y(),
              width: node.width() * scaleX,
              height: node.height() * scaleY,
              rotation: node.rotation(),
              ratio,
            }
          : img
      )
    );
    if (!isCtrlPressed) {
      node.scaleX(1);
      node.scaleY(1);
    }
  };

  useEffect(() => {
    var layers = backgroundDesign.layers;

    setImageLayers(prev => layers);
  }, [backgroundDesign]);

  useEffect(() => {
    if (selectLayer) {
      const findLayer = imageLayers.find((e) => e.id == selectLayer);
      const canvasElement = stateRef.current;
      const findi = canvasElement.find(`#${selectLayer}`);
      if (findi.length > 0 && findi[0]) {
        transformerRef.current.nodes([findi[0]]);
        transformerRef.current.getLayer().batchDraw();
      }
    }
  }, [selectLayer]);

  const handleSelect = (e, index, id) => {
    onSelectLayer(id);
    setImageLayers((prev) =>
      prev.map((img, i) => ({
        ...img,
        isSelected: i === index ? true : false,
      }))
    );

    if (transformerRef.current) {
      transformerRef.current.nodes([e.target]);
      transformerRef.current.getLayer().batchDraw();
    }
  };
  const onDeSelect = () => {
    if (transformerRef.current) {
      onSelectLayer(null);
      transformerRef.current.nodes([]);
      transformerRef.current.getLayer().batchDraw();
    }
  };

  const changePosition = (arr, index, newPosition) => {
    if (
      index >= arr.length ||
      index < 0 ||
      newPosition >= arr.length ||
      newPosition < 0
    ) {
      return arr;
    }
    let newArr = [...arr];
    let elementToMove = newArr.splice(index, 1)[0];
    newArr.splice(newPosition, 0, elementToMove);
    return newArr;
  };

  const handleMoveAdvanceOneLayer = () => {
    const findLayer = imageLayers.find((e) => e.id == menuVisiblelayerID);
    const index = imageLayers.indexOf(findLayer);
    const newPosition = index + 1;
    const newLayers = changePosition(imageLayers, index, newPosition);
    setImageLayers(newLayers);
    setMenuVisible(false);
  };

  const handleMoveBackOneLayer = () => {
    const findLayer = imageLayers.find((e) => e.id == menuVisiblelayerID);
    const index = imageLayers.indexOf(findLayer);
    const newPosition = index - 1;
    const newLayers = changePosition(imageLayers, index, newPosition);
    setImageLayers(newLayers);
    setMenuVisible(false);
  };

  const checkDisableDown = () => {
    const findLayer = imageLayers.find((e) => e.id == menuVisiblelayerID);
    const index = imageLayers.indexOf(findLayer);
    if (index == imageLayers.length - 1) {
      return true;
    }
    return false;
  };

  const checkDisableUp = () => {
    const findLayer = imageLayers.find((e) => e.id == menuVisiblelayerID);
    const index = imageLayers.indexOf(findLayer);
    if (index == 0) {
      return true;
    }
    return false;
  };
  // move

  const handleDragMove = (e, index) => {
    const node = e.target;

    const canvasCenterX = widthCanvas / 2;
    const canvasCenterY = widthCanvas / 2;
    const imageCenterX = node.x() + node.width() / 2;
    const imageCenterY = node.y() + node.height() / 2;

    // Kiểm tra xem hình ảnh có gần giữa không
    const nearCenterX =
      Math.abs(imageCenterX - canvasCenterX) < centerThreshold;
    const nearCenterY =
      Math.abs(imageCenterY - canvasCenterY) < centerThreshold;

    // Hiển thị đường kẻ nếu gần giữa
    setShowCenterLines({
      x: nearCenterX,
      y: nearCenterY,
    });
  };

  const handleChangeTopBar = (v) => {
    setImageLayers(v);
  }

  return (
    <>
      <TopBarDesign 
        backgrounds={backgrounds}
        selectLayer={selectLayer} 
        backgroundDesign={backgroundDesign}
        imageLayers={imageLayers}
        ratio={ratio}
        onChange={handleChangeTopBar}
        onApplyAll={onApplyAll}
        showCenterLinesStatutBtn={showCenterLinesStatutBtn}
        setShowCenterLinesStatutBtn={setShowCenterLinesStatutBtn}
      />
      <Stage ref={stateRef} width={widthCanvas} height={widthCanvas}>
        <Layer>
          <Image
            image={backgroundImage}
            width={widthCanvas}
            height={widthCanvas}
            onClick={onDeSelect}
            onTap={onDeSelect}
          />

          {imageLayers.map((img, index) => {
            return (
              <LayerImage
                key={img.id}
                imageLayer={img}
                onSelect={(e) => handleSelect(e, index, img.id)}
                isSelected={img.isSelected}
                onDragEnd={(e) => handleDragEnd(e, index)}
                onTransformEnd={(e) => handleTransformEnd(e, index)}
                onDragMove={(e) => handleDragMove(e, index)}
                isCtrlPressed={img.isSelected}
                setMenuVisiblePosition={setMenuVisiblePosition}
                setMenuVisible={setMenuVisible}
                setMenuVisibleLayerID={setMenuVisibleLayerID}
                ratio={ratio}
              />
            );
          })}
          {(showCenterLines.x || showCenterLinesStatutBtn) && (
            <DashedLine
              x1={widthCanvas / 2}
              y1={0}
              x2={widthCanvas / 2}
              y2={widthCanvas}
            />
          )}
          {(showCenterLines.y || showCenterLinesStatutBtn) && (
            <DashedLine
              x1={0}
              y1={widthCanvas / 2}
              x2={widthCanvas}
              y2={widthCanvas / 2}
            />
          )}
          <Transformer
            ref={transformerRef}
            rotateEnabled
            anchorSize={8}
            strokeScaleEnabled
            enabledAnchors={[
              "top-left",
              "top-right",
              "bottom-left",
              "bottom-right",
            ]}
          />
        </Layer>
      </Stage>
      <SelectBackgroundEdit
        backgroundDesign={backgroundDesign}
        layerID={layerID}
        backgrounds={backgrounds}
        onChangeBgCurrentEditID={onChangeBgCurrentEditID}
        onChangeBackground={onChangeBackground}
      />
      {menuVisible && (
        <>
          <div
            onClick={() => setMenuVisible(false)}
            style={{
              position: "fixed",
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
            }}
          ></div>
          <ul
            id="customContextMenu"
            style={{
              position: "fixed",
              top: menuVisiblePosition.y,
              left: menuVisiblePosition.x,
              backgroundColor: "white",
              border: "1px solid #ccc",
              boxShadow: "2px 2px 5px rgba(0,0,0,0.2)",
              listStyleType: "none",
              borderRadius: "8px",
              padding: "0",
              margin: "0",
              zIndex: 1000,
            }}
          >
            <li style={{ padding: "2px", cursor: "pointer" }}>
              <button
                className="btn-menu-context"
                type="text"
                disabled={checkDisableDown()}
                onClick={handleMoveAdvanceOneLayer}
              >
                <BiLayerPlus />
                <span style={{ marginLeft: "8px" }}>Advance one class</span>
              </button>
            </li>
            <li style={{ padding: "2px", cursor: "pointer" }}>
              <button
                className="btn-menu-context"
                type="text"
                disabled={checkDisableUp()}
                onClick={handleMoveBackOneLayer}
              >
                <BiLayerMinus />
                <span style={{ marginLeft: "8px" }}>Move back one class</span>
              </button>
            </li>
          </ul>
        </>
      )}
    </>
  );
};

export default Design;
